import { ComponentRef, Injectable, Injector, ViewContainerRef } from '@angular/core';
import { DynamicElementService } from '../../services/dynamicElement.service';
import { WidgetDock } from '../../util/WidgetDock';
import { WidgetType } from '../../util/WidgetType';
import { WidgetWrapperComponent } from '../widget-wrapper/widget-wrapper.component';
import { ToolbarWidgetWrapperComponent } from './widget-wrapper/toolbar-widget-wrapper.component';

@Injectable()
export class ToolbarWidgetDock extends WidgetDock {
  constructor(
    protected widgetWrapperInsertionPoint: ViewContainerRef,
    protected widgetWrapperInsertionPointFloating: ViewContainerRef,
    protected dynamicElementService: DynamicElementService,
  ) {
    super(widgetWrapperInsertionPoint, dynamicElementService);
  }

  protected createComponentReference(widgetType: WidgetType, injector: Injector): ComponentRef<WidgetWrapperComponent> {
    const componentRef = this.widgetWrapperInsertionPoint.createComponent(ToolbarWidgetWrapperComponent, {
      injector: injector,
    });

    // Save the componentRef of the wrapper in the wrapper itself
    (<ToolbarWidgetWrapperComponent>componentRef.instance).wrapperComponentRef = componentRef;
    (<ToolbarWidgetWrapperComponent>componentRef.instance).widgetWrapperInsertionPoint = this.widgetWrapperInsertionPoint;
    (<ToolbarWidgetWrapperComponent>componentRef.instance).widgetWrapperInsertionPointFloating = this.widgetWrapperInsertionPointFloating;

    return componentRef;
  }

  protected removeWrapperFromDOM(wrapperComponentRef?: ComponentRef<WidgetWrapperComponent>) {
    super.removeWrapperFromDOM(wrapperComponentRef);

    if (wrapperComponentRef) {
      const index = this.widgetWrapperInsertionPointFloating.indexOf(wrapperComponentRef.hostView);

      if (index >= 0) {
        this.widgetWrapperInsertionPoint.remove(index);
      }
    }
  }

  public detachWidget(widgetName: string): ComponentRef<WidgetWrapperComponent> | null {
    const ref = super.detachWidget(widgetName);

    if (ref) {
      const viewIndex = this.widgetWrapperInsertionPointFloating.indexOf(ref.hostView);

      if (viewIndex >= 0) {
        this.widgetWrapperInsertionPointFloating.detach(viewIndex);
        this.refs.delete(widgetName);
      }
    }

    return ref;
  }
}
